/*
	This mixin is used to adjust the size of the various components
	being used in the form based of the width of the window.
*/

export default {
	data() {
		return {
			size: {
				button: 'large',
				dropdown: 'large',
				field: true,
				tags: true,
			},
		};
	},

	mounted() {
		this.adjustBasedOnWidth();

		window.addEventListener('resize', this.adjustBasedOnWidth);
	},

	beforeDestroy() {
		window.removeEventListener('resize', this.adjustBasedOnWidth);
	},

	methods: {
		adjustBasedOnWidth() {
			// String that represent the fact that the component is large or normal
			this.size.button = window.innerWidth > 768 ? 'large' : 'standard';
			this.size.dropdown = window.innerWidth > 768 ? 'large' : 'normal';

			// Boolean that represent the fact that the component is large or normal
			this.size.field = window.innerWidth > 768;
			this.size.tags = window.innerWidth > 768;
		},
	},
};
